module.exports = __webpack_public_path__ + "img/15.0761a055.png";